<!-- @format -->
<template>
    <div class="widget collateral-publish-widget">
        <div class="widget-header">
            <h3>Publish to Partners</h3>
            <div class="svg-container widget-close-button" @click="closeWidget">
                <widget-close-svg />
            </div>
        </div>
        <div class="content-wrapper">
            <p>
                Please select which partners you would like this collateral item to be published to:
            </p>
            <client-published-collateral-display
                primary
                :collateralId="collateralId"
                @update:selectedItems="updateSelectedClients($event)"
            />
        </div>
        <div class="widget-footer">
            <div class="cancel-container">
                <app-button class="transparent-btn" @click="closeWidget">Cancel</app-button>
            </div>
            <div class="action-container">
                <app-button :loading="isSaving" @click="save">
                    {{ isSaving ? 'Saving' : 'Save' }}
                </app-button>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button');
const ClientPublishedCollateralDisplay = () =>
    import('@/components/client/client-published-collateral-display');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');

import EventBus from '@/scripts/event-bus.js';

export default {
    name: 'collateral-publish-widget',

    components: {
        'app-button': AppButton,
        'client-published-collateral-display': ClientPublishedCollateralDisplay,
        'widget-close-svg': WidgetCloseSvg,
    },

    props: {
        widget: {
            type: Object,
            default: null,
        },
    },

    data() {
        return {
            isInitializing: true,
            isSaving: false,
            collateralId: null,
            agencyId: null,
            selectedClients: [],
        };
    },

    created() {
        this.collateralId = this.widget.collateralId;
        this.getCollateral();
    },

    destroyed() {},

    methods: {
        updateSelectedClients(selectedClients) {
            this.selectedClients = selectedClients;
        },

        save() {
            this.isSaving = true;
            var clientIds = this.selectedClients.map((client) => {
                return client.id;
            });

            this.$api
                .post(`/api/Collaterals/${this.collateralId}/Publish`, clientIds)
                .then(() => {
                    this.$helpers.showSuccessNotification(
                        'Your publish settings have been updated.'
                    );
                    this.isSaving = false;

                    EventBus.$emit('collateral:update');
                    this.closeWidget();
                })
                .catch((error) => {
                    this.$helpers.showFailNotification(
                        'An error occurred while saving your publish settings.',
                        { error },
                    );
                    this.isSaving = false;
                });
        },

        getCollateral() {
            this.$api
                .get(`/service/Collaterals/?$filter=Id eq ${this.collateralId}`)
                .then((response) => {
                    this.agencyId = response.data.value[0].AgencyId;
                    this.isInitializing = false;
                })
                .catch((error) => {
                    this.$helpers.showFailNotification(
                        'An error occurred while getting your collateral settings.',
                        { error },
                    );
                    this.closeWidget();
                    this.isInitializing = false;
                });
        },

        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },
    },
};
</script>

<style>
.collateral-publish-widget .saving-step {
    text-align: center;
}

.collateral-publish-widget .content-wrapper {
    padding: 20px;
}

.collateral-publish-widget .action-container {
    display: flex;
}

.collateral-publish-widget .action-container .btn {
    margin-left: 15px;
}

.collateral-publish-widget .cancel-container .btn.transparent-btn {
    background: transparent;
    color: #877d88;
}

.collateral-publish-widget .cancel-container .btn.transparent-btn:hover {
    background: #e1e0e5;
}

.collateral-publish-widget .action-container .btn.white-btn {
    background: #ffffff;
    color: #877d88;
    border: 2px solid #e9e9ef;
}
</style>
